const FORM_SELECTOR = '.careers-application-updated';
const SECTION_SELECTOR = '.careers-application-updated-section';
const FIELD_SELECTOR = '.careers-application-updated__field';
const INPUT_SELECTOR = '.careers-application-updated__input, .careers-application-updated__control';
const CLONE_SELECTOR = '.careers-application-updated__clone';
const CLONE_INNER = '.careers-application-updated__clone-inner';
const CLONE_REMOVE_ICON = /* html */`
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M7.29102 21.875C6.7181 21.875 6.22765 21.671 5.81966 21.263C5.41168 20.855 5.20768 20.3646 5.20768 19.7917V6.25C4.91254 6.25 4.66515 6.15017 4.46549 5.95052C4.26584 5.75087 4.16602 5.50347 4.16602 5.20833C4.16602 4.91319 4.26584 4.6658 4.46549 4.46615C4.66515 4.26649 4.91254 4.16667 5.20768 4.16667H9.37435C9.37435 3.87153 9.47417 3.62413 9.67383 3.42448C9.87348 3.22483 10.1209 3.125 10.416 3.125H14.5827C14.8778 3.125 15.1252 3.22483 15.3249 3.42448C15.5245 3.62413 15.6243 3.87153 15.6243 4.16667H19.791C20.0862 4.16667 20.3335 4.26649 20.5332 4.46615C20.7329 4.6658 20.8327 4.91319 20.8327 5.20833C20.8327 5.50347 20.7329 5.75087 20.5332 5.95052C20.3335 6.15017 20.0862 6.25 19.791 6.25V19.7917C19.791 20.3646 19.587 20.855 19.179 21.263C18.7711 21.671 18.2806 21.875 17.7077 21.875H7.29102ZM17.7077 6.25H7.29102V19.7917H17.7077V6.25ZM11.1582 17.4089C11.3579 17.2092 11.4577 16.9618 11.4577 16.6667V9.375C11.4577 9.07986 11.3579 8.83247 11.1582 8.63281C10.9585 8.43316 10.7112 8.33333 10.416 8.33333C10.1209 8.33333 9.87348 8.43316 9.67383 8.63281C9.47417 8.83247 9.37435 9.07986 9.37435 9.375V16.6667C9.37435 16.9618 9.47417 17.2092 9.67383 17.4089C9.87348 17.6085 10.1209 17.7083 10.416 17.7083C10.7112 17.7083 10.9585 17.6085 11.1582 17.4089ZM15.3249 17.4089C15.5245 17.2092 15.6243 16.9618 15.6243 16.6667V9.375C15.6243 9.07986 15.5245 8.83247 15.3249 8.63281C15.1252 8.43316 14.8778 8.33333 14.5827 8.33333C14.2875 8.33333 14.0401 8.43316 13.8405 8.63281C13.6408 8.83247 13.541 9.07986 13.541 9.375V16.6667C13.541 16.9618 13.6408 17.2092 13.8405 17.4089C14.0401 17.6085 14.2875 17.7083 14.5827 17.7083C14.8778 17.7083 15.1252 17.6085 15.3249 17.4089Z" fill="#5D5D5D"/>
  </svg>
`;

/**
 * Careers application (updated)
 */
(() => {
  const query = document.querySelector(FORM_SELECTOR);
  if (!query) return;

  query.querySelector('.fake-email')?.remove();

  const firstSection = query.querySelector('section');

  document.querySelectorAll(SECTION_SELECTOR).forEach((item) => {
    query.append(item);
  });

  if (firstSection) {
    query.append(firstSection);
  }

  const responseMessage = query.querySelector('.response-message');
  if (responseMessage) {
    const anchor = firstSection || query.querySelector('.careers-application-updated__submit-row');
    if (anchor) {
      anchor.before(responseMessage);
    } else {
      query.append(responseMessage);
    }
  }

  query.querySelectorAll(INPUT_SELECTOR).forEach((item) => {
    if (!item.required) return;

    const field = item.closest(FIELD_SELECTOR) || item.closest('fieldset') || item.closest('[role="group"]');
    const wrappingLabel = item.closest('label.careers-application-updated__label');
    const label = wrappingLabel?.querySelector('input, select, textarea') === item
      ? null
      : wrappingLabel
        || field?.querySelector('legend.careers-application-updated__label')
        || field?.querySelector('.careers-application-updated__label');

    if (label && !label.querySelector('.careers-application-updated__required')) {
      label.insertAdjacentHTML('beforeend', ' <span class="careers-application-updated__required">*</span>');
    }
  });

  const generateJSON = (form) => {
    const newForm = form.cloneNode(true);
    newForm.querySelectorAll('input[type="hidden"], .g-recaptcha-response').forEach((item) => {
      item.remove();
    });

    const formData = new FormData(newForm);
    const json = {};

    for (const [key, value] of formData) {
      json[key] = value;
    }

    return JSON.stringify(json);
  };

  query.addEventListener('submit', (e) => {
    const payload = generateJSON(e.target);

    if (query.querySelector('.customJSON')) {
      query.querySelector('.customJSON').setAttribute('value', payload);
    } else {
      query.insertAdjacentHTML('beforeend', /* html */`
        <input class="hide customJSON" name="json" type="text" value='${payload}'/>
      `);
    }
  });
})();

/**
 * Clone section
 */
(() => {
  const query = document.querySelectorAll(CLONE_SELECTOR);
  if (!query.length) return;

  query.forEach((item) => {
    const clone = item.querySelector(`${CLONE_INNER} > *:last-of-type`).cloneNode(true);

    let addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'btn-custom primary careers-application-updated__clone-add';
    addBtn.textContent = 'Add A Row';

    addBtn.addEventListener('click', () => {
      const newClone = clone.cloneNode(true);

      newClone.querySelectorAll('input, select, textarea').forEach((input) => {
        let i = 1;
        let { name } = input;

        while (document.querySelector(`[name*="${name}"]`) && i < 100) {
          i += 1;
          name = `${input.name}_${i}`;
        }
        input.name = name;
      });

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'careers-application-updated__clone-remove';
      removeBtn.setAttribute('aria-label', 'Remove row');
      removeBtn.innerHTML = CLONE_REMOVE_ICON;

      removeBtn.addEventListener('click', () => {
        newClone.remove();
      });

      newClone.append(removeBtn);
      item.querySelector(CLONE_INNER).append(newClone);
    });

    item.append(addBtn);
  });
})();

const bindDisableHandlers = (attr, toggleFn) => {
  const root = document.querySelector(FORM_SELECTOR);
  if (!root) return;

  root.querySelectorAll(`[${attr}]`).forEach((item) => {
    item.addEventListener('change', (e) => {
      const targetClass = item.getAttribute(attr);
      root.querySelectorAll(`.${targetClass}`).forEach((ele) => {
        toggleFn(ele, e);
      });
    });
  });
};

bindDisableHandlers('data-disable-toggle', (ele, e) => {
  ele.classList.toggle('disabled-area', e.target?.checked ?? false);
});

bindDisableHandlers('data-disable-enable', (ele) => {
  ele.classList.toggle('disabled-area', false);
});

bindDisableHandlers('data-disable-disable', (ele) => {
  ele.classList.toggle('disabled-area', true);
});
